export default "__VITE_ASSET__DfKjbN6V__"